import React, { useState } from 'react';
import ArtworkReactions from '../components/ArtworkReactions';
import BackButton from '../components/BackButton';

const KudosTestPage = () => {
  const [testArtworks] = useState([
    {
      id: 'test-artwork-1',
      title: 'Sunset Over Mountains',
      imageUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
      artistName: 'Test Artist 1'
    },
    {
      id: 'test-artwork-2',
      title: 'Ocean Waves',
      imageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
      artistName: 'Test Artist 2'
    },
    {
      id: 'test-artwork-3',
      title: 'Forest Path',
      imageUrl: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=300&fit=crop',
      artistName: 'Test Artist 3'
    }
  ]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-amber-100 to-amber-200 p-6">
      <div className="max-w-6xl mx-auto">
        <BackButton className="mb-6" />
        
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-amber-800 mb-4">
            Kudos System Test
          </h1>
          <p className="text-lg text-amber-700">
            Test the kudos and comments functionality locally
          </p>
          <div className="mt-4 p-4 bg-amber-100 border-2 border-amber-300 rounded-lg">
            <p className="text-amber-800">
              ℹ️ This is a test page. Please log in to test kudos functionality.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testArtworks.map((artwork) => (
            <div
              key={artwork.id}
              className="bg-white/80 backdrop-blur-sm border-2 border-amber-200 rounded-xl shadow-lg p-4 hover:shadow-xl transition-shadow"
            >
              <img
                src={artwork.imageUrl}
                alt={artwork.title}
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              
              <h3 className="text-lg font-semibold text-amber-800 mb-2">
                {artwork.title}
              </h3>
              
              <p className="text-sm text-amber-600 mb-4">
                Artist: {artwork.artistName}
              </p>
              
              <div className="space-y-3">
                <ArtworkReactions 
                  artworkId={artwork.id} 
                  artistId="test-artist-1"
                  onKudosChange={(count) => {
                    console.log(`Kudos count for ${artwork.title}:`, count);
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white/80 backdrop-blur-sm border-2 border-amber-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold text-amber-800 mb-4">
            Test Instructions
          </h2>
          <div className="space-y-2 text-amber-700">
            <p>• Click the thumbs up button to give kudos to the artwork</p>
            <p>• The kudos count will update in real-time</p>
            <p>• Kudos notifications will be sent to the artist</p>
            <p>• Click "Comment" to add comments about the artwork</p>
            <p>• View existing comments by clicking the comment count</p>
            <p>• Check the browser console for API response logs</p>
            <p>• <strong>Note:</strong> You need to be logged in to give kudos and comment</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KudosTestPage; 